module.exports = __webpack_public_path__ + "img/example.4db0a0a8.svg";